module.exports = __webpack_public_path__ + "ab328552d624ddd94ea7ef7576b3d7c0.png";